// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import faqCategoryReducer from '../pages/Faq/redux/faqCategorySlice'; 

import languageReducer from '../pages/Languages/redux/LanguageSlice'

// other reducers

const store = configureStore({
  reducer: {
    // other reducers
    faqCategories: faqCategoryReducer,
    languages: languageReducer,
  },
});

export default store;
